// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"7f025a7d","144":"0dddfa5d","691":"25f55639","787":"edd59a96","868":"c91c6398"}[chunkId] + ".chunk.js";
};